(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const sectionEl = document.querySelector('.product-recommendations');

  function loadProductRecommendations() {
    const { limit, url } = sectionEl.dataset;

    fetch(sectionEl.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const div = document.createElement('div');
        div.innerHTML = responseText;

        const rec = div.querySelector('.product-recommendations');
        if (rec && rec.innerHTML.trim().length) {
          document.querySelector('.product-recommendations').innerHTML = rec.innerHTML;

          // Call the function to attach the click event after the new content is added
          attachImageChangeHandler();
        }

        if (typeof theme !== 'undefined' && typeof theme.initProductTitleAlignmentWatcher === 'function') {
          theme.initProductTitleAlignmentWatcher(sectionEl, '.productRecommendations');
        }
      })
      .catch((error) => {
        console.log('Fetch error:', error);
      });
  }

  // Function to attach click event handler for image swatch
  function attachImageChangeHandler() {
  $(".product-swatch-inline__dot").click(function () {
    var mainImageId = $(this).attr("main-image");
    var newImage = $(this).attr("data-image");
    var old_img = `#${mainImageId} img`;
    $(old_img).attr("src", newImage).on("load", function () {});
  });

  $(document).off('click.makfix', '.mak-atc').on('click.makfix', '.mak-atc', function(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    var productId = $(this).attr('data-product-id');
    var drawer = $('#side-drawer-' + productId);
    var variantId = drawer.find('select.product-form__variants').val();
    console.log('ATC clicked - productId:', productId, '| variantId:', variantId);
    if (!variantId) return;
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: { id: parseInt(variantId), quantity: 1 },
      dataType: 'json',
      success: function() { window.location.href = '/cart'; },
      error: function(err) { console.error('ATC error:', err); }
    });
  });  
}


  document.addEventListener('shopify:section:load', (e) => {
    if (sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
